
(function(){
function initTrack(track){
if(track.__sjwaSeg)return;track.__sjwaSeg=1;
var th=document.createElement('span');th.className='sjwa-segthumb';th.setAttribute('aria-hidden','true');track.appendChild(th);
function place(anim){
var on=track.querySelector('.sjwpp-tab.on');
if(!on||!on.offsetWidth){th.style.opacity='0';return;}
if(!anim){th.style.transition='none';}
th.style.opacity='1';th.style.width=on.offsetWidth+'px';
th.style.transform='translate3d('+on.offsetLeft+'px,0,0)';
if(!anim){void th.offsetWidth;th.style.transition='';}
}
try{new MutationObserver(function(){place(true);}).observe(track,{attributes:true,subtree:true,attributeFilter:['class'],childList:true});}catch(e){}
window.addEventListener('resize',function(){place(false);},{passive:true});
place(false);setTimeout(function(){place(false);},350);setTimeout(function(){place(false);},1200);
}
function scan(){var ts=document.querySelectorAll('[id^="sjwpp-"] .sjwpp-tabs');for(var i=0;i<ts.length;i++)initTrack(ts[i]);}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',scan);}else{scan();}
setTimeout(scan,400);setTimeout(scan,1500);
})();
